import { useState, useEffect, useContext } from "react"
import { TbVotes } from "../../components/tables/TbVotes"
import { validateVotes } from "../../helpers/validateForms"
import { ContextApp } from "../../context/ContextApp"

import Titulo from "../../components/titles/Titulo"
import InputSearch from "../../components/inputs/inputs/InputSearch"
import InputJim from "../../components/inputs/inputs/InputJim"
import ModalConfirm from "../../components/ModalComfirm/ModalConfirm"

import '../pageStyles.css'
import './votes.css'

const Votes = () => {

  const initialErrors = {
    dirip: ''
  }

  const { loginUp, token, refreshToken, cancion, pueblo, voto } = useContext(ContextApp);

  const [vote, setVote] = useState(voto)
  const [votes, setVotes] = useState([])
  const [votesFiltred, setVotesFiltred] = useState([])

  const [songs, setSongs] = useState([])
  const [villages, setVillages] = useState([])
  const [showModal, setShowModal] = useState(false);
  const [showForm, setShowForm] = useState(false)
  const [errors, setErrors] = useState(initialErrors);

  useEffect(() => {
    const loadData = async () => {
      try {
        await refreshToken();

        const songData = await cancion.getSongs();
        setSongs(await songData)
        const villageData = await pueblo.getVillages();
        setVillages(await villageData)

        const data = await voto.getVotes();
        setVotes(await data);
        setVotesFiltred(await data);
      } catch (error) {
        console.log(error.message)
      }
    }
    loadData();
  }, [voto, cancion, pueblo, loginUp,refreshToken])

  const filterData = (data) => {
    const newData = votes.filter((vote) => vote.PUE_NOMBRE.toLowerCase().includes(data.toLowerCase()))

    setVotesFiltred(newData)
  }

  const handleChange = (name, value) => {
    setVote({ ...vote, [name]: value })
  }

  const onChangeSelect = (e) => {
    const { name, value } = e.target
    handleChange(name, value)
  }

  const validateData = async(name, value) => {
    const error = await validateVotes(name, value)
    setErrors(prevErrors =>{
        return {...prevErrors, [name]:error}
      })
  }

  const sendForm = async () => {
    try {
      await refreshToken()

      
      await validateData('dirip', vote.dirip);

      console.log(villages[0].PUE_CLAVE)
      console.log(vote)
      
      if(await validateVotes('dirip', vote.dirip) === ''){
        
        if(vote.idVillage === '') vote.idVillage = villages[0].PUE_CLAVE
        console.log(vote)
        setVotesFiltred(await voto.addVote(vote, token))

        setShowForm(false)
        setVote('')
      }
    } catch (error) {
      // MOSTRAR ERROR DE VOTO DUPLICADO
      console.log(error)
    }

  }

  const deleteVote = async (e) => {
    setShowModal(!showModal) 

    await refreshToken()
       
    console.log(vote)

    const data = await voto.delVote(vote, token)
    setVotesFiltred(data)
    setVote(voto)
  }
  const showPopup = (e) => {
    setVote(e)
    setShowModal(!showModal) 
  }

  return (
    <>
    <div className="container-data">

      <section className="data-body">

        <section className="data-header">
          <Titulo>VOTACIÓN</Titulo>

          <InputSearch
            placeholder='nombre a buscar'
            onChange={filterData} />
          <button className="material-icons-outlined btn" onClick={() => setShowForm(!showForm)}>add</button>
        </section>
        {votes &&
          <section className="data-table">

            <TbVotes
              votes={votesFiltred}
              deleteVote={showPopup} />

          </section>
        }
      </section>

      <section className="data-edit">
        {showForm &&
          <section className="data-form">

            <select className="select-container select-input span"
              name="idVillage"
              value={vote.idVillage}
              onChange={onChangeSelect}
            >
              {villages && villages.map((item) => (
                <option key={item.PUE_CLAVE} value={item.PUE_CLAVE} >
                  {item.PUE_NOMBRE}
                </option>
              ))}
            </select>
            <select className="select-container select-input span"
              name="idSong"
              value={vote.idSong}
              onChange={onChangeSelect}
            >
              {songs && songs.map((item) => (
                <option key={item.CAN_CLAVE} value={item.CAN_CLAVE} >
                  {item.CAN_TITULO}
                </option>
              ))}
            </select>

            <InputJim classN='span'
              type='text'
              name='dirip'
              value={vote.dirip}
              onChange={handleChange}
              onBlur={validateData}
              placeholder='escribe IP'
              error={errors.dirip} />
            <button className="btn posButton" onClick={sendForm}>ENVIAR</button>
          </section>
        }
        <div className={showForm ? "data-logo hidden" : "data-logo"} />
      </section>

    </div>

    {showModal &&
  <ModalConfirm title='Confirmar eliminación' showPopup={showPopup}>
    <>
      <section className='modal-message'>
        <h2>Vas a eliminar el voto</h2>
        <h2> {vote.CAN_TITULO} ({vote.PUE_NOMBRE}) </h2>
      </section>
      <section className='modal-buttons'>
        <button onClick={deleteVote}>ACEPTAR</button>
        <button onClick={showPopup}>CANCELAR</button>
      </section>
    </>
  </ModalConfirm>
}
    </>
  )
}
export default Votes